import { render } from "./AuthPage.vue?vue&type=template&id=d6e92a08&scoped=true"
import script from "./AuthPage.vue?vue&type=script&lang=js"
export * from "./AuthPage.vue?vue&type=script&lang=js"

import "./AuthPage.vue?vue&type=style&index=0&id=d6e92a08&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d6e92a08"]])

export default __exports__